import get from 'lodash/get';

const MessageHandler = {
  SET_NAVIGATION_STATE: 'stencilSetNavigationState',
  SET_BUSY_STATE: 'stencilSetBusyState',
  CARD_READER_HANDLER: 'stencilListenForHighPowerCardReaderEvents',
  PRINTER_HANDLER: 'stencilPrintHTMLReceipt',
  OPEN_CASH_DRAWER_HANDLER: 'stencilOpenCashDrawer',
  CHANGE_SHOP_HANDLER: 'stencilChangeShopAndRegister',
  SHOW_PIN_LOCK_SCREEN: 'stencilRequestPINLock',
  STENCIL_SIGNATURE_HANDLER: 'stencilCaptureSignature',
  SHOW_NOTIFICATION: 'stencilShowNotification',
  SAVE_RESULT: 'stencilSaveResult',
  FIRST_START_COMPLETE_HANDLER: 'stencilFirstStartComplete',
  START_PAYMENT_TERMINAL_TRANSACTION: 'stencilStartPaymentTerminalTransaction',
  START_PAYMENT_REFUND_BY_REFERENCE: 'stencilStartPaymentTerminalRefundByReference',
};

export const hasRetailManagerContext = () =>
  !!get(window, `webkit.messageHandlers.${MessageHandler.SET_NAVIGATION_STATE}`);
